import React from 'react'
import Browser from '../browser'

const BrowserNl = () => {
    return <Browser languageCode="nl" />
}

export default BrowserNl
